import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Spinner} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import { formatarValor, formatarValorAPI, validaSenha, MidiasAceita } from '../../common/utils';
import { IMaskInput } from "react-imask";
import axios from 'axios';
import { FaCheck, FaEye, FaEyeSlash } from "react-icons/fa";
import logomarca from '../../assets/images/logomarca.png';

import { getConfig } from "../../common/config";

class PrestadoresCadastro extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleLaboratorioVinculadoChange = this.handleLaboratorioVinculadoChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        this.onChangeCep = this.onChangeCep.bind(this);
        this.handleMidiasContatoChange = this.handleMidiasContatoChange.bind(this);
        this.handleTermoDinamicoChange = this.handleTermoDinamicoChange.bind(this);

        this.list_tipos_pessoa = {
            "fisica": "Física", 
            "juridica": "Jurídica"
        };
        this.list_categorias = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais",
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clínicas",
            "plataformas": "Plataformas",
            "laboratorio_diagnostico": "Laboratórios de Análise Clínica",
            "cooperativas_saude": "Cooperativas de Saúde",
        };
        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino",
            "O": "Outro",
        },
        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

        this.state = {
            nome: '',
            cpf: '',
            cnpj: '',
            email: "",
            razao_social: "",
            nome_fantasia: "",
            tipo_pessoa: "fisica",
            telefone: "",
            celular: "",
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            uf: '',
            cidade: '',
            genero: '',
            registro: '',
            registro_uf: '',
            categoria: 'medicos',
            contato_nome: '',
            contato_email: '',
            contato_celular: '',
            senha: '',
            senha_confirma: '',
            midias_contato: ["email","whatsapp","telefone"],
            nomeHelper: "",
            cpfHelper: "",
            cnpjHelper: "",
            emailHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            telefoneHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            contatoNomeHelper: '',
            contatoEmailHelper: '',
            contatoCelularHelper: '',
            titulo_pagina: "",
            loading: false,
            erroLoadRegistro: '',
            prestador_id: '',
            clientes: [],
            laboratorios: [],
            programas: [],
            programa_dados: [],
            termo_conteudo: "",
            showTermsModal: false,
            aceitaTermos: false,
            mostrarSenha: { senha: false, senhaConfirma: false },
            programa_uuid: '',
            loading_render: true,
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
            laboratoriosDisponiveis: [], // Lista de laboratórios disponíveis
            laboratoriosSelecionados: [], // IDs dos laboratórios selecionados
            cadastro_teste: false,
            podeCadastrar: false,
            is_active: true,
            termosDinamicosHabilitado: false,
            termosDinamicosQuestions: [],
            termosDinamicosAnswers: {},
        };
    }

    componentDidMount(){

        const searchParams = new URLSearchParams(this.props.router.location.search);
        const programa_uuid = searchParams.get('p');

        // Verifica se ambos os parâmetros estão presentes
        if (!programa_uuid) {
            // Redireciona para a página de login se não estiverem presentes
            window.location.href = '/login/?error=1';
        }
        else {
            this.setState({ programa_uuid: programa_uuid });

            this.carregaDadosPrograma(programa_uuid);
        }
    }

    carregarLaboratoriosDisponiveis = async () => {
        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }

        try {
            const response = await api.get(`/pessoas/prestadores/limitado/?programa_uuid=${this.state.programa_uuid}&categoria=laboratorio_diagnostico`, config);
        
            const opcoes = response.data.results
                .filter(laboratorio => !laboratorio.exclusivo_vinculados) // Filtra laboratórios onde exclusivo_vinculados é false
                .map(laboratorio => ({
                    id: laboratorio.id,
                    nome: laboratorio.nome_fantasia
                }));

            this.setState({ laboratoriosDisponiveis: opcoes });
        } catch (error) {
            console.error('Erro ao carregar laboratorios:', error);
            return [];
        }
    }

    handleLaboratorioVinculadoChange = (laboratorioId) => {
        if(laboratorioId == 'nenhum') {
            this.setState({ laboratoriosSelecionados: [] });
        } else {
            this.setState(prevState => {
                const novosSelecionados = prevState.laboratoriosSelecionados.includes(laboratorioId)
                    ? prevState.laboratoriosSelecionados.filter(id => id !== laboratorioId)
                    : [...prevState.laboratoriosSelecionados, laboratorioId];
    
                console.log("Laboratórios selecionados após atualização:", novosSelecionados);
    
                return { laboratoriosSelecionados: novosSelecionados };
            });
        }
    }

    verificaRequisitosSenha = (senha) => {
        const requisitos = {
            tamanho: senha.length > 8,
            minuscula: /[a-z]/.test(senha),
            maiuscula: /[A-Z]/.test(senha),
            numero: /[0-9]/.test(senha),
            especial: /[$@#&!]/.test(senha)
        };
        this.setState({ requisitosSenha: requisitos });
    }

    carregaDadosPrograma = (programa_uuid) => {     
        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }

        api.get(`/programas/${programa_uuid}/`, config)
        .then(response => {
            const programaData = response.data || {};
            const termosDinamicosConfig = programaData.configuracoes?.Termos_Dinamicos || {};
            const termosDinamicosQuestions = Array.isArray(termosDinamicosConfig?.Questions) ? termosDinamicosConfig.Questions : [];

            this.setState({
                programa_dados: programaData,
                termosDinamicosHabilitado: termosDinamicosConfig?.habilitado_termo_dinamico_medico === true,
                termosDinamicosQuestions
            }, () => {

                if (this.state.programa_dados.termo_prestador_id) {
                    api.get(`/termos/${this.state.programa_dados.termo_prestador_id}`, config)
                    .then(responseTermos => {
                        const dados = responseTermos.data;

                        this.carregarLaboratoriosDisponiveis();
        
                        //preenche os inputs
                        this.setState({
                            titulo_pagina: `Realize seu Cadastro no Programa ${this.state.programa_dados.nome}`,
                            termo_conteudo: dados.texto,
                            loading: false,
                            loading_render: false     
                        })
                    })
                    .catch(errorTermos => {
                        console.error('Erro ao carregar dados do programa atual:', errorTermos);
                        
                        window.location.href = `/login/?error=4&p=${programa_uuid}`;
                        
                    });
                } else {
                    window.location.href = `/login/?error=3&p=${programa_uuid}`;
                }
            });
        })
        .catch(error => {
            console.error('Erro ao carregar dados do programa atual:', error);
            
            window.location.href = `/login/?error=2&p=${programa_uuid}`;
        });
    };

    toggleTermsModal = () => {
        this.setState(prevState => ({ showTermsModal: !prevState.showTermsModal }));
    }

    handleTermoDinamicoChange(slug, value) {
        this.setState((prev) => ({
            termosDinamicosAnswers: {
                ...prev.termosDinamicosAnswers,
                [slug]: value
            }
        }));
    }

    getFirstNameAndLastName(fullName) {
        const parts = fullName.trim().split(' ');
        const lastName = parts.pop(); // Remove e retorna o último elemento
        const firstName = parts.join(' '); // Junta os elementos restantes como o primeiro nome
        return { firstName, lastName };
    }

    generateUsername(email) {
        return email.replace(/[^a-zA-Z]/g, '');
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        if (!this.state.senha) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                text: 'Por favor, preencha o campo senha.',
                showCloseButton: true,
            });
            return; // Para interromper a execução se houver erro
        }

        if (!validaSenha(this.state.senha)) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Senha Fraca',
                text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                showCloseButton: true,
            });
            return;
        }

        if (this.state.senha !== this.state.senha_confirma) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'As senhas não coincidem.',
                showCloseButton: true,
            });
            return; // Para interromper a execução se houver erro
        }
    
        if (!this.state.aceitaTermos) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Política do Programa',
                text: 'Você precisa aceitar a política do programa para prosseguir.',
                showCloseButton: true,
            });
            return; // Para interromper a execução se houver erro
        }

        if (this.state.termosDinamicosHabilitado) {
            const MySwal = withReactContent(Swal);
            const erros = [];
            let mensagemBloqueio = '';

            this.state.termosDinamicosQuestions.forEach((q) => {
                if (!q || !q.slug) return;
                const valor = this.state.termosDinamicosAnswers[q.slug];

                if (q.obrigatorio && (valor === undefined || valor === null || valor === '')) {
                    erros.push(q.label || q.slug);
                }

                const regraBloqueio = q.regra_bloqueio_cadastro || {};
                if (regraBloqueio.ativo === true && valor === regraBloqueio.quando_valor) {
                    mensagemBloqueio = regraBloqueio.mensagem || 'Não é possível continuar com as opções selecionadas.';
                }
            });

            if (mensagemBloqueio) {
                MySwal.fire({
                    icon: 'error',
                    title: 'Cadastro bloqueado',
                    text: mensagemBloqueio,
                    showCloseButton: true,
                });
                return;
            }

            if (erros.length > 0) {
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    text: 'Preencha os consentimentos obrigatórios antes de continuar.',
                    showCloseButton: true,
                });
                return;
            }
        }

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            cpfHelper: "",
            cnpjHelper: "",
            emailHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            telefoneHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            contatoNomeHelper: '',
            contatoEmailHelper: '',
            contatoCelularHelper: '',
        });

        //verifica se é edição ou adição
        const url = (this.state.prestador_id) ? '/pessoas/prestadores/'+this.state.prestador_id+'/' : '/pessoas/prestadores/';
        const metodo = (this.state.prestador_id) ? 'put' : 'post';    
        
        const midiasContatoString = this.state.midias_contato.join(',');
        const laboratoriosString = this.state.laboratoriosSelecionados.join(',');

        const dados_extras = getConfig(this.state.programa_dados.configuracoes, 'cadastro_medico.dados_extras', false);

        formData.append('nome', (this.state.tipo_pessoa == 'fisica') ? this.state.nome : this.state.razao_social);
        if(dados_extras) {
            formData.append('cpf_cnpj', (this.state.tipo_pessoa == 'fisica') ? this.state.cpf : this.state.cnpj);
            formData.append('genero', this.state.genero);
        }
        formData.append('email', this.state.email);
        formData.append('tipo_pessoa', this.state.tipo_pessoa);
        formData.append('celular', this.state.celular);
     
        formData.append('categoria', this.state.categoria);   
        formData.append('registro', this.state.registro);
        formData.append('registro_uf', this.state.registro_uf);


        formData.append('senha', this.state.senha);
        
        //if (this.state.programa_dados.grupo_cadastro_medico_id) {
            formData.append('grupo_id', this.state.programa_dados.grupo_cadastro_medico_id);
        //}

        formData.append('programa_uuid', this.state.programa_uuid);

        if(midiasContatoString) {
            formData.append('midias_contato', midiasContatoString);
        } else {
            formData.append('midias_contato', "");
        }

        if(laboratoriosString) {
            formData.append('laboratorios', laboratoriosString);
        } else {
            formData.append('laboratorios', "");
        }

        formData.append('is_active', this.state.is_active);
        if (this.state.termosDinamicosHabilitado) {
            formData.append('termos_dinamicos_respostas_json', JSON.stringify(this.state.termosDinamicosAnswers || {}));
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
        
            MySwal.fire({
                title: 'Cadastro Criado',
                html: <p>Cadastro criado com sucesso, faça seu login a seguir</p>,
                icon: 'success',
                showCloseButton: true,
                didClose: () => {
                    window.location.href = `/login/?success=1&p=${this.state.programa_uuid}`;
                }
            });
            
            this.setState({ loading: false });            
        })
        .catch(error => {
            let erro_msg = "Não foi possível realizar o cadastro<br />";                

            console.log(error.response)

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento, por favor tente novamente.';
            }
            else if(error.response && error.response.status === 400){
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;             
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                                     
                    if(key === 'nome'){
                        erro_msg += "<br />Nome: " + value;
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        erro_msg += "<br />CPF / CNPJ: " + value;
                        this.setState({ 
                            cpfHelper: value,
                            cnpjHelper: value
                        })
                    }
                    if(key === 'email'){
                        erro_msg += "<br />E-mail: " + value;
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'razao_social'){
                        erro_msg += "<br />Razão Social: " + value;
                        this.setState({ razaoSocialHelper: value })
                    }
                    if(key === 'nome_fantasia'){
                        erro_msg += "<br />Nome Fantasia: " + value;
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'tipo_pessoa'){
                        erro_msg += "<br />Tipo de Pessoa: " + value;
                        this.setState({ tipoPessoaHelper: value })
                    }
                    if(key === 'telefone'){
                        erro_msg += "<br />Telefone: " + value;
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'celular'){
                        erro_msg += "<br />Celular: " + value;
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'endereco'){
                        erro_msg += "<br />Endereço: " + value;
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        erro_msg += "<br />Número: " + value;
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        erro_msg += "<br />Complemento: " + value;
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        erro_msg += "<br />Bairro: " + value;
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cep'){
                        erro_msg += "<br />CEP: " + value;
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'uf'){
                        erro_msg += "<br />UF: " + value;
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'cidade'){
                        erro_msg += "<br />Cidade: " + value;
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'genero'){
                        erro_msg += "<br />Gênero: " + value;
                        this.setState({ generoHelper: value })
                    }
                    if(key === 'registro'){
                        if(value == "O CRM informado já existe.") {
                            erro_msg += "<br />CRM já cadastrado, por favor, entre com o seu login e senha.";
                        } else {
                            erro_msg += "<br />CRM: " + value;
                        }
                        this.setState({ registroHelper: value })
                    }
                    if(key === 'registro_uf'){
                        if(value == "O CRM informado já existe.") {
                            erro_msg += "<br />CRM já cadastrado, por favor, entre com o seu login e senha.";
                        } else {
                            erro_msg += "<br />CRM: " + value;
                        }
                        this.setState({ registroUfHelper: value })
                    }
                    if(key === 'contato_nome'){
                        erro_msg += "<br />Nome de Contato: " + value;
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_email'){
                        erro_msg += "<br />E-mail de Contato: " + value;
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'contato_celular'){
                        erro_msg += "<br />Celular de Contato: " + value;
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'username'){
                        erro_msg += "<br />" + value;
                        this.setState({ registroHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    consultaCpfCnpj = (valor) => {
        setTimeout(() => {
            this.setState({ loading: true });

            let config = {
                headers: {
                    'X-USERNAME': import.meta.env.VITE_X_USERNAME,
                }
            }

            //consulta o prestador na api
            api.get(`/pessoas/prestadores/?cpf_cnpj=${valor}`, config)
            .then(response => {
                const results = response.data.results;

                if(results.length > 0){
                    const item = results[0];

                    this.setState({ prestador_id: item.id });                    
                }
                else {
                    this.setState({ prestador_id: '' });                    
                }

                this.setState({ loading: false });
            });
        }, 500);
    }

    handleChange = (event, fieldName) => {        
        if(fieldName == 'beneficiario_id') {
            this.setState({ beneficiario_id: event.value, beneficiario_nome: event.label });
        }
        else if (fieldName == "servico_procedimento_id") {
            this.setState({ servico_procedimento_id: event.value, servico_procedimento_nome: event.label });
        }
        else if (fieldName == "situacao") {
            this.setState({ situacao: event.value, situacao_nome: event.label });
        }
        else if (fieldName == "valor") {
            const { name, value } = event.target;
            this.setState({ [name]: formatarValor(value) });
        }
        else {
            const { name, value } = event.target;

            if(name === "email") {
                this.setState({ [name]: value.toLowerCase() });
            } else {
                this.setState({ [name]: value });
            }
            
            if (name === "senha") {
                this.verificaRequisitosSenha(value);
            }

            /*if(value.length == 14 && name == 'cpf'){
                this.consultaCpfCnpj(value);
            }

            if(value.length == 18 && name == 'cnpj'){
                this.consultaCpfCnpj(value);
            }*/
        }
    };

    handleMidiasContatoChange = (midia, isChecked) => {
        const midias_contato = [...this.state.midias_contato];
    
        if (isChecked) {
            midias_contato.push(midia);
        } else {
            const index = midias_contato.indexOf(midia);
            if (index > -1) {
                midias_contato.splice(index, 1);
            }
        }
    
        this.setState({ midias_contato });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    onChangeCep(e) {
        const cep = e.target.value;
        this.setState({ cep: cep });

        if (cep.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        this.setState({
                            endereco: res.data.logradouro,
                            complemento: res.data.complemento,
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        });
                    } else {
                        // Tratar o caso de CEP não encontrado
                        console.log("CEP não encontrado.");
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    carregarLaboratorios = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&categoria=laboratorio_diagnostico|servicos_diagnostico|clinicas|hospitais|cooperativas_saude`);
            const opcoes = response.data.results.map(laboratorio => ({
                value: laboratorio.id,
                label: `${laboratorio.dados_pessoa.nome_fantasia} (${laboratorio.dados_pessoa.razao_social})`
            }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar laboratorios:', error);
            return [];
        }
    };

    // Função para alternar a visibilidade da senha
    toggleSenhaVisibilidade = campo => {
        this.setState(prevState => ({
            mostrarSenha: { ...prevState.mostrarSenha, [campo]: !prevState.mostrarSenha[campo] }
        }));
    }

    async consultaCRM() {
        const MySwal = withReactContent(Swal);

        let config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        }

        if(!this.state.registro || !this.state.registro_uf) {
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                text: 'Por favor, preencha o CRM e UF',
                showCloseButton: true,
            });
            return;
        }

        this.setState({
            loading: true
        })

        try {
            const response = await api.get(
                `/pessoas/crm/?registro=${this.state.registro}&uf=${this.state.registro_uf}`,
                config
            );
            const data = response.data;
        
            if (data.valido) {
                // caso válido: libera cadastro e salva nome
                this.setState({
                    podeCadastrar: true,
                    nome: data.dados_medico.nome_medico,
                    loading: false
                });
            } else {
                // caso inválido: bloqueia cadastro e mostra a mensagem de erro
                this.setState({ podeCadastrar: false, loading: false });
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    text: 'O CRM informado não é válido.',
                    showCloseButton: true,
                });
            }
        } catch (error) {
            this.setState({ loading: false });
            if (error.response && error.response.data) {
                const data = error.response.data;
                this.setState({ podeCadastrar: false });
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    text: 'O CRM informado não é válido.',
                    showCloseButton: true,
                });
            } else {
                // 3c) erro de rede ou outro
                console.error('Erro na consulta CRM:', error);
                MySwal.fire({
                    icon: 'error',
                    title: 'Ops...',
                    text: 'Não foi possível verificar o CRM. Tente novamente mais tarde.',
                    showCloseButton: true,
                });
            }
        }
    }


    render(){

        if (this.state.loading_render) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" style={{ color: '#fff' }} />
                </div>
            );
        }

        let dynamicStyles = '';
        if(this.state.programa_dados) {
            if(this.state.programa_dados.layout_cor_fundo && this.state.programa_dados.layout_cor_primaria && this.state.programa_dados.layout_cor_secundaria) {
                dynamicStyles = `
                    #root::before {
                        background: ${this.state.programa_dados.layout_cor_fundo};
                    }
                    .btn-first {
                        background: ${this.state.programa_dados.layout_cor_primaria};
                        border-color: ${this.state.programa_dados.layout_cor_primaria};
                    }
                    .btn-secondary {
                        background: ${this.state.programa_dados.layout_cor_secundaria};
                        border: 1px solid ${this.state.programa_dados.layout_cor_secundaria};
                    }
                    .btn-secondary:hover {
                        background: ${this.state.programa_dados.layout_cor_secundaria};
                        border: 1px solid ${this.state.programa_dados.layout_cor_secundaria};
                        opacity: 0.9;
                    }
                    .btn-success {
                        background: ${this.state.programa_dados.layout_cor_secundaria};
                        border-color: ${this.state.programa_dados.layout_cor_secundaria};
                    }
                    .btn-success:hover {
                        background: ${this.state.programa_dados.layout_cor_secundaria};
                        border-color: ${this.state.programa_dados.layout_cor_secundaria};
                        opacity: 0.9;
                    }
                    .form-check-input:checked {
                        background-color: ${this.state.programa_dados.layout_cor_secundaria};
                        border-color: ${this.state.programa_dados.layout_cor_secundaria};
                    }
                `;
            }
        }

        // Função helper - pode colocar fora da classe ou como método estático
        function isLightBackground(dynamicStyles) {
            if (!dynamicStyles) return false;

            const bgColor = (dynamicStyles.backgroundColor || dynamicStyles.background || '').toLowerCase().replace(/\s/g, '');

            // Lista de cores claras conhecidas
            const lightColors = [
                '#ffffff', '#fff', '#f8f9fa', '#f5f5f5', '#f0f0f0',
                '#e8e8e8', '#e0e0e0', '#d9d9d9', '#fafafa', '#f7f7f7',
                'white', 'whitesmoke', 'snow', 'ghostwhite', 'ivory',
                'rgb(255,255,255)', 'rgb(248,249,250)', 'rgb(245,245,245)',
                'rgb(240,240,240)'
            ];

            return lightColors.includes(bgColor);
        }

        return (
            <div className="container">
                <style>
                    {dynamicStyles}
                </style>
                <Row className="mt-2 align-items-center justify-content-center">
                    <Col sm={8} lg={8}>
                        <Row className="align-items-center">
                            <Col sm={12} lg={12} className="text-center">
                                {this.state.programa_dados.imagem_branca && (
                                    <div className="mb-3">
                                        {dynamicStyles ? (
                                            <img 
                                                src={isLightBackground(dynamicStyles) 
                                                    ? this.state.programa_dados.imagem 
                                                    : this.state.programa_dados.imagem_branca} 
                                                alt={this.state.programa_dados.nome} 
                                                style={{ maxHeight: '80px', maxWidth: '200px' }} 
                                            />
                                        ) : (
                                            <img 
                                                src={this.state.programa_dados.imagem_branca} 
                                                alt={this.state.programa_dados.nome} 
                                                style={{ maxHeight: '80px', maxWidth: '200px' }} 
                                            />
                                        )}
                                    </div>
                                )}
                                <h4 className="page-title mb-4">{(this.state.programa_dados.nome) ? `Realize seu Cadastro no Programa ${this.state.programa_dados.nome}` : ``}</h4>
                            </Col>
                            <Col sm={12}>
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Form onSubmit={this.enviaRegistro}>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CRM <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control type="text" name="registro" required value={this.state.registro} onChange={this.handleChange} />    
                                                        <Form.Text id="registroHelper" className="text-danger">{this.state.registroHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>UF do CRM <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control as="select" name="registro_uf" value={this.state.registro_uf} required onChange={this.handleChange}>
                                                            <option value="">Selecione o Estado</option>
                                                            {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                <option key={sigla} value={sigla}>{nome}</option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Text id="registroUfHelper" className="text-danger">{this.state.registroUfHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>   

                                                <Col xs={12}>
                                                    <Button
                                                        type="button"
                                                        variant="secondary"
                                                        size="sm"
                                                        className="text-uppercase"
                                                        disabled={this.state.loading}
                                                        onClick={(e) => {
                                                            this.consultaCRM();
                                                        }}
                                                    >
                                                    {
                                                        !this.state.loading
                                                        ?
                                                        <span>Buscar</span>
                                                        :
                                                        <span><i className="spinner-border spinner-border-sm" /> &nbsp; Buscando...</span>
                                                    }
                    
                                                    </Button>
                                                </Col>
    
                                            </Row> 
                                                
                                            {this.state.podeCadastrar && (
                                            <Row className="mt-3">
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Nome <span className="text-danger"></span></Form.Label>
                                                        <Form.Control type="text" name="nome" required placeholder="Seu Nome" value={this.state.nome} onChange={this.handleChange} disabled={true} />    
                                                        <Form.Text id="nomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>E-mail <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control type="email" name="email" required placeholder="E-mail" value={this.state.email} onChange={this.handleChange} />    
                                                        <Form.Text id="emailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>                  
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Celular <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control as={IMaskInput} mask="(00) 00000-0000" required placeholder="Celular" name="celular" value={this.state.celular} onChange={this.handleChange} />
                                                        <Form.Text id="celularHelper" className="text-danger">{this.state.celularHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>  
                                                {getConfig(this.state.programa_dados.configuracoes, 'cadastro_medico.dados_extras', false) && (
                                                    <>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>CPF <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control as={IMaskInput} required mask="000.000.000-00" placeholder="CPF" name="cpf" value={this.state.cpf} onChange={this.handleChange} onPaste={this.handleChange} />
                                                                <Form.Text id="cpfHelper" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col sm={6} xs={12}>
                                                            <Form.Label>Gênero</Form.Label>
                                                            <div className="mb-3">
                                                            {
                                                                Object.keys(this.list_generos).map((key, index) => ( 
                                                                <Form.Check inline type="radio" label={this.list_generos[key]} key={key} id={key} name="genero" value={key} onChange={this.handleChange} checked={ key === this.state.genero ? true : false } />
                                                                ))
                                                            }                                              
                                                            </div>
                                                        </Col>
                                                    </>
                                                )}  
                                                {this.state.laboratoriosDisponiveis.length > 0 && getConfig(this.state.programa_dados.configuracoes, 'cadastro_medico.escolha_laboratorio', false) && (
                                                <Col sm={12}>
                                                    <h4 className="mt-3">Você faz parte do corpo clínico de alguma das redes abaixo?</h4>
                                                    <div className="d-flex flex-wrap">
                                                        <div key='nenhum' className="p-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                id={`nenhum`}
                                                                label="Nenhum"
                                                                checked={this.state.laboratoriosSelecionados.length === 0}
                                                                onChange={() => this.handleLaboratorioVinculadoChange('nenhum')}
                                                            />
                                                        </div>
                                                        {this.state.laboratoriosDisponiveis.map(laboratorio => (
                                                            <div key={laboratorio.id} className="p-2">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id={`laboratorio-${laboratorio.id}`}
                                                                    label={laboratorio.nome}
                                                                    checked={this.state.laboratoriosSelecionados.includes(laboratorio.id)}
                                                                    onChange={() => this.handleLaboratorioVinculadoChange(laboratorio.id)}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Col>
                                                )}
                                                <Col sm={12}>
                                                    <h4 className="mt-3">Aceita receber nossas comunicações em quais meios de contato?</h4>
                                                    <div className="d-flex flex-wrap">
                                                    {Object.keys(MidiasAceita).map((midia) => (
                                                        <div className="p-2" key={`midia-${midia}`}> {/* Ajuste o tamanho da coluna conforme necessário */}
                                                            <Form.Check 
                                                                type="checkbox"
                                                                id={`midia-${midia}`}
                                                                label={MidiasAceita[midia]}
                                                                checked={this.state.midias_contato.includes(midia)}
                                                                onChange={e => this.handleMidiasContatoChange(midia, e.target.checked)}
                                                            />
                                                        </div>
                                                    ))}
                                                    </div>
                                                </Col>
                                                <Col sm={12}>
                                                    <h4 className="mt-5">Dados de Acesso</h4>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Senha</Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senha ? "text" : "password"}
                                                            name="senha"
                                                            placeholder="Senha"
                                                            value={this.state.senha}
                                                            onChange={this.handleChange}
                                                            required
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senha')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senha ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                    <p className="mb-0">Requisitos da senha: </p>
                                                    <ul>
                                                        <li style={{ color: this.state.requisitosSenha.tamanho ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.tamanho ? '700' : '400' }}>
                                                            Quantidade de caracteres maior que 8 {this.state.requisitosSenha.tamanho && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.minuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.minuscula ? '700' : '400' }}>
                                                            Uma letra minuscula {this.state.requisitosSenha.minuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.maiuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.maiuscula ? '700' : '400' }}>
                                                            Uma letra maiuscula {this.state.requisitosSenha.maiuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.numero ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.numero ? '700' : '400' }}>
                                                            Um número de 0 a 9 {this.state.requisitosSenha.numero && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.especial ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.especial ? '700' : '400' }}>
                                                            Pelo menos um dos seguintes caracteres $@#&! {this.state.requisitosSenha.especial && <FaCheck />}
                                                        </li>
                                                    </ul>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Confirmar Senha</Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senhaConfirma ? "text" : "password"}
                                                            name="senha_confirma"
                                                            placeholder="Confirmar Senha"
                                                            value={this.state.senha_confirma}
                                                            onChange={this.handleChange}
                                                            required
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senhaConfirma')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senhaConfirma ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                </Col>
                                                {this.state.termosDinamicosHabilitado && this.state.termosDinamicosQuestions.length > 0 && (
                                                    <Col sm={12} className="mt-3">
                                                        {this.state.termosDinamicosQuestions.map((campo) => {
                                                            if (!campo?.slug) return null;
                                                            const valor = this.state.termosDinamicosAnswers[campo.slug];

                                                            return (
                                                                <div key={campo.slug} className="mb-3">
                                                                    <div className="fw-bold">{campo.label}</div>
                                                                    {campo.texto && (
                                                                        <div className="text-muted mb-2">{campo.texto}</div>
                                                                    )}

                                                                    {campo.tipo === 'radio' && Array.isArray(campo.opcoes) && (
                                                                        <div>
                                                                            {campo.opcoes.map((opcao, idx) => {
                                                                                const opcaoValor = typeof opcao === 'object' ? opcao?.valor : opcao;
                                                                                const opcaoLabel = typeof opcao === 'object' ? (opcao?.label ?? String(opcaoValor)) : String(opcao);
                                                                                return (
                                                                                    <Form.Check
                                                                                        key={`${campo.slug}-${idx}`}
                                                                                        type="radio"
                                                                                        id={`term-din-${campo.slug}-${idx}`}
                                                                                        name={`term-din-${campo.slug}`}
                                                                                        label={opcaoLabel}
                                                                                        checked={valor === opcaoValor}
                                                                                        onChange={() => this.handleTermoDinamicoChange(campo.slug, opcaoValor)}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    )}

                                                                    {campo.tipo === 'checkbox' && (
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            id={`term-din-${campo.slug}`}
                                                                            label={campo.checkbox_label || 'Confirmo'}
                                                                            checked={Boolean(valor)}
                                                                            onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.checked)}
                                                                        />
                                                                    )}

                                                                    {campo.tipo === 'text' && (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={valor || ''}
                                                                            onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                        />
                                                                    )}

                                                                    {campo.tipo === 'textarea' && (
                                                                        <Form.Control
                                                                            as="textarea"
                                                                            rows={3}
                                                                            value={valor || ''}
                                                                            onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                        />
                                                                    )}

                                                                    {campo.tipo === 'date' && (
                                                                        <Form.Control
                                                                            type="date"
                                                                            value={valor || ''}
                                                                            onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                        />
                                                                    )}

                                                                    {campo.observacao && (
                                                                        <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </Col>
                                                )}

                                                <Col sm={12} className="mt-3 d-flex align-items-center">
                                                    <Form.Check 
                                                        type="checkbox" 
                                                        id="aceitaTermosCheckbox" // Adicionando um ID ao checkbox
                                                        label={<label htmlFor="aceitaTermosCheckbox">Li e aceito os</label>} // Associando a label ao checkbox pelo ID
                                                        checked={this.state.aceitaTermos}
                                                        className="check-termos"
                                                        onChange={e => this.setState({ aceitaTermos: e.target.checked })}
                                                    />
                                                    { this.state.programa_dados.termos_programa_medicos ? (
                                                        <a className="link-inline text-dark ms-1" href={this.state.programa_dados.termos_programa_medicos} target="_blank">Termos do Programa</a>
                                                    ) : (
                                                        <Button variant="link-inline" onClick={this.toggleTermsModal} className="ms-1">{getConfig(this.state.programa_dados.configuracoes, 'cadastro_medico.termos_programa_texto', 'Termos do Programa')}</Button> 
                                                    )}

                                                    {this.state.programa_dados.regulamento_programa && (
                                                        <>
                                                            , <a className="link-inline text-dark ms-1" href={this.state.programa_dados.regulamento_programa} target="_blank">Regulamento do Programa</a>
                                                        </>
                                                    )}
                                                    {this.state.programa_dados.aviso_privacidade && (
                                                        <>
                                                            , <a className="link-inline text-dark ms-1 me-1" href={this.state.programa_dados.aviso_privacidade} target="_blank">Aviso de Privacidade</a>
                                                        </>
                                                    )}
                                                    {this.state.programa_dados.politica_cookies && (
                                                        <>
                                                            , <a className="link-inline text-dark ms-1" href={this.state.programa_dados.politica_cookies} target="_blank">Política de Cookies</a>
                                                        </>
                                                    )}
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    {this.state.erroLoadRegistro ? 
                                                    <Alert variant="warning">
                                                        {this.state.erroLoadRegistro}
                                                    </Alert> : ''
                                                    }                                      
                                                    <Button variant="success" type="submit" className="btn-submit mt-5" disabled={this.state.loading || !this.state.aceitaTermos}>
                                                        {this.state.loading ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : (
                                                            <>
                                                                <FaCheck className="me-1" /> Cadastrar
                                                            </>
                                                        )}
                                                    </Button>
                                                </Col>
                                            </Row>
                                            )}
                                        </Form>                                     
                                    </Card.Body>                
                                </Card>

                                {this.state.programa_dados.imagem_branca && (
                                    <div className="mt-5 text-center">
                                        <p>Powered by <a href="https://aditushealth.com.br" target="_blank"><img src={logomarca} alt="Aditus Health" style={{ maxWidth: '60px' }} /></a></p>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Modal show={this.state.showTermsModal} onHide={this.toggleTermsModal} size="lg">
                    <Modal.Body>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: this.state.termo_conteudo }} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.toggleTermsModal}>Fechar</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default withRouter(PrestadoresCadastro);
